class SchedItem {
    constructor(name, desc, head, loc, day, timeS, timeE, xp) {
        this.name = name;
        this.desc = desc;
        this.head = head;
        this.loc = loc;
        this.day = day;
        this.start = timeS;
        this.end = timeE;
        this.xp = xp;
    }
    toJSON() {
        return {
            name: this.name,
            desc: this.desc,
            head: this.head,
            loc: this.loc,
            day: this.day,
            start: this.start,
            end: this.end,
            xp: this.xp
        };
    }
}
function sort(scheduled) {
    const timeRaw = (s, c) => Number(s?.start?.split(":")[c]);
    const mins = (s) => (timeRaw(s, 0) * 60) + timeRaw(s, 1);
    const timeNum = (a, b) => mins(a) - mins(b);
    return scheduled.filter(s => s?.day == tab && !s?.unlisted).sort((a, b) => timeNum(a, b));
}
export { SchedItem, sort };